/**
 * /tracks/archive — every published track ever, newest first, paginated.
 */

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { getArchive } from '../api/tracks.js';
import TrackTile from '../components/tracks/TrackTile.jsx';
import './tracks.css';


const PAGE_SIZE = 24;


export default function ArchivePage() {
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getArchive(page, PAGE_SIZE)
      .then((result) => { if (!cancelled) setData(result); })
      .catch((e) => { if (!cancelled) setError(e.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [page]);

  const totalPages = data ? Math.max(1, Math.ceil(data.total / PAGE_SIZE)) : 1;

  return (
    <div className="tt-page dot-grid">
      <header className="tt-pageheader">
        <Link to="/" className="tt-crumb">~/home</Link>
        <span className="tt-crumb-sep"> / </span>
        <Link to="/tracks" className="tt-crumb">tracks</Link>
        <span className="tt-crumb-sep"> / </span>
        <span className="tt-crumb tt-crumb--here">archive</span>

        <h1 className="tt-pagetitle">The Vault</h1>
        <p className="tt-pagesub">
          Every track Timmy has ever blessed us with.
          {data && (
            <span className="tt-pagesub__count">
              {' '}· {data.total} {data.total === 1 ? 'pick' : 'picks'}
            </span>
          )}
        </p>
      </header>

      {error && <div className="tt-error">{error}</div>}

      {loading ? (
        <div className="tt-muted">cracking the vault…</div>
      ) : data && data.items.length > 0 ? (
        <>
          <div className="tt-archive-grid">
            {data.items.map((t) => (
              <TrackTile key={t.id} track={t} />
            ))}
          </div>

          {totalPages > 1 && (
            <nav className="tt-pagination" aria-label="Archive pages">
              <button
                type="button"
                className="tt-btn"
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
              >
                ← newer
              </button>
              <span className="tt-pagination__counter">
                page {page} / {totalPages}
              </span>
              <button
                type="button"
                className="tt-btn"
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              >
                older →
              </button>
            </nav>
          )}
        </>
      ) : (
        <div className="tt-muted">the vault is empty. for now.</div>
      )}
    </div>
  );
}
